import { useQueries, UseQueryResult } from "react-query";
import { RetailProductAvailabilityType } from "../../../../types/airgraft";
import { fetchRetailProviderProductAvailability } from "../utils";

export type RetailProductAvailabilityQueryResultsType = Record<
  string,
  UseQueryResult<RetailProductAvailabilityType, unknown>
>;

export default function useRetailProvidersProductAvailability(
  productId: string,
  retailProviderIds: string[]
): RetailProductAvailabilityQueryResultsType {
  const results = useQueries(
    retailProviderIds.map(retailProviderId => {
      return {
        queryKey: [
          "retail-provider-product-availability",
          productId,
          retailProviderId
        ],
        queryFn: () =>
          fetchRetailProviderProductAvailability(productId, retailProviderId),
        retry: 2
      };
    })
  );
  return results.reduce((accumulator, result, index) => {
    return {
      ...accumulator,
      [retailProviderIds[index]]: result
    };
  }, {} as RetailProductAvailabilityQueryResultsType);
}
